var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgFlagFilled = function SvgFlagFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillOpacity: 0.18,
    d: "M5 4h1v17H5z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillOpacity: 0.18,
    stroke: "currentColor",
    strokeLinejoin: "round",
    strokeWidth: 1.6,
    d: "M6 4.2c.55-.2 1.15-.2 1.85 0 1.15.35 2.2.95 3.7.95 1.15 0 2.05-.4 2.95-.8.55-.25 1.15-.5 1.85-.5.45 0 .85.35.85.85v7.7c0 .35-.2.65-.55.8-.75.35-1.45.65-2.35.65-1.15 0-2.05-.4-2.95-.8-.95-.4-1.9-.8-3.15-.8-1 0-1.85.3-2.55.6-.25.1-.5-.05-.5-.35V4.55c0-.2.1-.4.3-.5.3-.15.65-.25 1-.25z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeWidth: 1.6,
    d: "M5 21V4"
  })));
};
export default SvgFlagFilled;